import { CloseIcon } from '@braskai/icons';
import { ModalWrapper } from '@braskai/ui-kit';
import { useNavigate } from 'react-router-dom';

import { PATHS } from '@/shared/constants/routes/paths';
import { useInterfaceLanguage } from '@/shared/i18n';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { SActions, SBody, SCloseButton, SPrimaryButton, SScroll } from '../../../ui/upsell/styled';
import { usePlanFeaturesModalStore, usePlanFeaturesModalTrigger } from '../../model/usePlanFeaturesModal';
import { PlanFeaturesContent } from './PlanFeaturesContent';
import { SDialog, STitle } from './styled';

const TITLE_ID = 'plan-features-modal-title';

const PlanFeaturesModalComponent = () => {
  const { t } = useInterfaceLanguage();
  const navigate = useNavigate();
  const close = usePlanFeaturesModalStore((state) => state.close);
  const trigger = usePlanFeaturesModalStore((state) => state.trigger);

  const handleClose = () => {
    MixpanelEvents.paidTrialPlanFeaturesDismissed({ trigger });
    close();
  };

  const handleUpgrade = () => {
    MixpanelEvents.paidTrialPlanFeaturesCtaClick({ trigger });
    close();
    navigate(`/${PATHS.pricing}`, {
      state: { path: window.location.pathname, pricingEntryPoint: 'paid_trial_plan_features' },
    });
  };

  return (
    <SDialog aria-labelledby={TITLE_ID} data-testid="plan-features-modal" $wide open onClose={handleClose}>
      <SCloseButton aria-label={t('common.close')} data-testid="plan-features-modal-close" $wide onClick={handleClose}>
        <CloseIcon />
      </SCloseButton>
      <SScroll>
        <SBody $flow="download">
          <STitle id={TITLE_ID}>{t('paidTrial.planFeatures.title')}</STitle>
          <PlanFeaturesContent />
          <SActions $marginTop={28.5} $stack>
            <SPrimaryButton
              $scale="offer"
              data-testid="plan-features-modal-upgrade"
              size="lg"
              fullWidth
              onClick={handleUpgrade}
            >
              {t('account.trialUpgrade.upgradePlan')}
            </SPrimaryButton>
          </SActions>
        </SBody>
      </SScroll>
    </SDialog>
  );
};

export const PlanFeaturesModal = () => {
  usePlanFeaturesModalTrigger();

  return (
    <ModalWrapper hook={usePlanFeaturesModalStore}>
      <PlanFeaturesModalComponent />
    </ModalWrapper>
  );
};
